'use client';

import { useEffect, useState } from 'react';

import Link from 'next/link';

const ANNOUNCEMENT_URL = '/about-lips/news-and-events/lips-affidea-partnership';
const DISPLAY_DURATION_MS = 5_000;

export function HomepageAnnouncementNotification() {
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    const timeoutId = window.setTimeout(
      () => setIsVisible(false),
      DISPLAY_DURATION_MS,
    );

    return () => window.clearTimeout(timeoutId);
  }, []);

  if (!isVisible) return null;

  return (
    <aside
      role="status"
      aria-live="polite"
      className="border-theme-primary/15 fixed right-4 bottom-5 left-4 z-50 mx-auto max-w-md rounded-xl border bg-white p-4 shadow-xl md:right-8 md:bottom-8 md:left-auto"
    >
      <button
        type="button"
        aria-label="Dismiss Affidea announcement"
        onClick={() => setIsVisible(false)}
        className="hover:text-theme-primary absolute top-2 right-3 text-xl leading-none text-gray-500 transition-colors"
      >
        ×
      </button>

      <p className="text-theme-primary pr-7 text-sm font-bold">
        LIPS Healthcare × Affidea
      </p>
      <p className="mt-1 pr-5 text-sm leading-relaxed text-gray-700">
        A new partnership expanding consultant-led care across London.
      </p>
      <Link
        href={ANNOUNCEMENT_URL}
        aria-label="Read the LIPS Healthcare and Affidea partnership announcement"
        className="text-text-action mt-3 inline-block text-sm font-bold underline underline-offset-4"
      >
        Read the announcement
      </Link>
    </aside>
  );
}
